<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200" :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="排班表" prop="duty_pic">
              <multi_upload ref="warehouseDutyPic"></multi_upload>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submit">保存</Button>
        </FormItem>

      </Form>
    </card>

  </div>
</template>
<script>
import {warehouseDutyDetailApi, warehouseDutySaveApi} from '@/api/warehouse/warehouseDuty'
import multi_upload from '_c/multi_upload'
import {imgFormat} from "_c/common/imgFormat";

export default {
  name: 'warehouseDutyEdit',
  //引入组件
  components: {multi_upload},
  data() {
    return {
      formData: {
        id: 1,
        duty_pic: '',
      },
      ruleValidate: {
        duty_pic: [
          {required: true, message: '请上传排班表', trigger: 'blur'}
        ],
      },
    }
  },
  mounted() {
      this.loadFormData(this.formData.id)
  },
  methods: {
    //提交数据
    submit() {

      console.log(this.$refs.warehouseDutyPic.uploadPics)
      console.log(this.formData.duty_pic)
      //单图获取
      if (this.$refs.warehouseDutyPic.uploadPics.length > 0) {
        this.formData.duty_pic = this.$refs.warehouseDutyPic.uploadPics[0].url;
      } else {
        this.formData.duty_pic = ''
      }

      // 验证表单数据
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          // 验证失败 停止提交
          this.$Message.error('请检查输入内容!');
          return false;
        } else {
          // 验证通过 请求接口
          warehouseDutySaveApi(this.formData).then(res => {
            if (res.code === 200) {

              this.$Message.success('成功')

              setTimeout(() => {
                this.$router.back()
              }, 500)

            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 编辑加载数据
    loadFormData(id) {
      warehouseDutyDetailApi(id).then(res => {
        //数据赋值
        if (res.data) {
          this.formData = res.data
        }

        //图片赋值
        if (this.formData.duty_pic) {
          this.$refs.warehouseDutyPic.uploadPics = [];
          this.$refs.warehouseDutyPic.uploadPics.push(imgFormat(this.formData.duty_pic))
        }

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
